import React from 'react';
import { StarFour } from 'phosphor-react';


interface AiBetaButtonProps {
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  id?: string;
}

const AiBetaButton: React.FC<AiBetaButtonProps> = ({ disabled = false, onClick, id }) => {
  return (
    <div
      id={id}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        width: 129,
        height: 43,
        padding: '8px 21px',
        borderRadius: 40,
        background: 'linear-gradient(96.18deg, #4248FF -14.15%, #931FFF 103.76%)',
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        border: 'none',
        marginLeft: '8px',
      }}
      onClick={(e) => {
        if (!disabled) {
          onClick?.(e);
        }
      }}
    >
      <span style={{ fontSize: 16, fontWeight: 600, color: 'white' }}>AI</span>
      <StarFour size={16} color="white" weight="fill" />
      <span style={{ fontSize: 14, fontWeight: 600, color: 'white' }}>BETA</span>
    </div>
  );
};

export default AiBetaButton;
